export default "__VITE_ASSET__B6HTbdD___"